import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

@Injectable({ providedIn: 'root' })
export class HospitalServicesService extends ApiBaseService<any> {
  constructor() {
    super('hospitalServices');
  }
}
